import styled from 'styled-components'

export default styled.div`
    margin-bottom: ${({ theme }) =>theme.paddingBox};
    width: 100%;
    position: relative;
    z-index: 2000;
`
